<template>
    <div class="card buildingCard">
        <div class="card-body buildingCard-body">
            <slot name="title"></slot>
            <dl class="card-text buildingCard-list" v-if="dead_line !== undefined">
                <dt class="afss-deadline">
                    <strong>
                        AFSS Deadline:
                        <ToolTip>
                            <sup class="superScript">
                                <i class="fas fa-info-circle"
                                   data-toggle="tooltip"
                                   data-placement="top"
                                   data-html="true"
                                   title=""
                                   data-original-title='The date you must submit the certificate'
                                ></i>
                            </sup>
                        </ToolTip>
                    </strong>
                </dt>
                <dd>{{ tools.formatDateWithOutYear(deadLine, buildingTimeZone) }}</dd>
                <dt>Test Start Lead Time:
                    <ToolTip>
                        <sup class="superScript">
                            <i class="fas fa-info-circle"
                               data-toggle="tooltip"
                               data-placement="top"
                               data-html="true"
                               title=""
                               data-original-title='Preferred number of days before the AFSS deadline that the test should first run'
                            ></i>
                        </sup>
                    </ToolTip>
                </dt>
                <dd>{{ leadTime }} days</dd>
                <dt>Test Start Time:
                    <ToolTip>
                        <sup class="superScript">
                            <i class="fas fa-info-circle"
                               data-toggle="tooltip"
                               data-placement="top"
                               data-html="true"
                               title=""
                               data-original-title='Preferred time of day that the test should run'
                            ></i>
                        </sup>
                    </ToolTip>
                </dt>
                <dd>{{ tools.formatTime(deadLine, buildingTimeZone) }}</dd>
                <dt>Test Zone:</dt>
                <dd>{{ tools.getTimeZoneOffset(deadLine, buildingTimeZone).zone }}<br>
                  ({{ tools.getTimeZoneOffset(deadLine, buildingTimeZone).difference }})
                </dd>
            </dl>
            <div v-else>
                <p>No AFSS deadline configured.</p>
            </div>
        </div>
        <RequiresSitePermissions v-bind:required-permissions="['WRITE']" v-bind:site-id="buildingId">
            <button class="buildingCard-edit" v-on:click="showFormCard">
                    <i class="fas fa-pen"></i>
                    <span class="sr-only">Edit</span>
            </button>
        </RequiresSitePermissions>
    </div>
</template>
<style>
</style>
<script>
  import Tools from '@/app-model/tools.js'
  import RequiresSitePermissions from '@/components/RequiresSitePermissions.vue'
  import ToolTip from '@/components/tool-tip/ToolTip.vue'
  export default {
    props: {
      lead_time: Number,
      dead_line: Number,
      afssInformation: Object,
      buildingTimeZone: String,
      buildingId: Number,
    },
    data() {
      return {
      }
    },
    components: {
      RequiresSitePermissions,
      ToolTip
    },

    computed: {
      tools: function () {
        return new Tools
      },

      leadTime: function() {
        return this.lead_time;
      },
      deadLine: function() {
        return new Date(this.dead_line*1000);
      }
    },
    methods: {
      showFormCard : function () {
        this.$emit('showFormCard', true)
      },
    },
  }
</script>
<style lang="scss" scoped>
    @import "@/../sass/_building_card.scss";
</style>